import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "./../../components/panel/panel.jsx";
import { getERInstructions, deleteERinstruction } from "./../../services/erinstructions";
import { getCompanys } from "./../../services/companies";
import "bootstrap/dist/css/bootstrap.min.css";
import Pagination from "../../common/pagination";
import { paginate } from "../../utils/paginate";
import ERInstructionTable from "../../components/erinstructionsTable.jsx";
import SearchBox from "./../../common/searchBox";
import _ from "lodash";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Icons imports
import newIcon from "../../assets/Icons/new.svg";
import editIcon from "../../assets/Icons/edit.svg";
import trashIcon from "../../assets/Icons/trash.svg";
import csvIcon from "../../assets/Icons/csv.svg";
import xlsIcon from "../../assets/Icons/xls.svg";
import pdfIcon from "../../assets/Icons/pdf.svg";
import importIcon from "../../assets/Icons/import.svg";
import sharingIcon from "../../assets/Icons/sharing.svg";
import eyeIcon from "../../assets/Icons/eye.svg";
import Icon from "./../../common/icon";

class ERInstructionsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      erinstructions: [],
      checkedFields: [],
      pageSize: 10,
      count: 0,
      currentPage: 1,
      sortColumn: { path: "name", order: "asc" },
      searchQuery: "",
      errors: {},
    };
  }

  async componentDidMount() {
    document.title = "ERInstructions";    
    try {
      const [{ data: erinstructions }, { data: companies }] = await Promise.all([
        getERInstructions(),
        getCompanys()
      ]);
      
      const companiesMap = companies.reduce((map, company) => {
        map[company._id] = company;
        return map;
      }, {});
      
      const enrichedERInstructions = erinstructions.map(wi => {
        const businessNoId = typeof wi.businessNo === 'object' ? wi.businessNo._id : wi.businessNo;
        const matchedCompany = companiesMap[businessNoId];
        
        return {
          ...wi,
          companyinfo: matchedCompany || null
        };
      });
      
      console.log('🔵 [DEBUG] ER Instructions data loaded:', enrichedERInstructions);
      console.log('🔵 [DEBUG] First ER instruction fieldType:', enrichedERInstructions[0]?.fieldType);
      console.log('🔵 [DEBUG] First ER instruction serviceType:', enrichedERInstructions[0]?.serviceType);
      console.log('🔵 [DEBUG] All fields in first item:', Object.keys(enrichedERInstructions[0] || {}));
      console.log('🔵 [DEBUG] Latest item (your creation):', enrichedERInstructions[enrichedERInstructions.length - 1]);
      
      this.setState({ erinstructions: enrichedERInstructions });
    } catch (ex) {
      console.error('Failed to load ER Instructions:', ex);
      
      // Show user-friendly error message
      toast.warning("Backend endpoint not available. Using demo data for testing.");
      
      // Use mock data temporarily until backend is implemented
      const mockERInstructions = [
        {
          _id: "demo-er-1",
          name: "Heart Attack Emergency Response",
          description: "Immediate steps for cardiac arrest emergency",
          category: "heart-attack", 
          fieldType: "Medical",
          serviceType: "Paramedic",
          version: "1.0",
          language: "English",
          tags: "cardiac, emergency, CPR",
          status: "active",
          actions: [
            { name: "Call 911 immediately", step: "1" },
            { name: "Check for responsiveness", step: "2" },
            { name: "Begin CPR if unresponsive", step: "3" }
          ],
          user: {
            _id: "user1",
            contactName: { first: "Dr. Sarah", last: "Johnson" },
            imageSrc: null
          },
          businessNo: null,
          companyinfo: null,
          createdOn: new Date().toISOString()
        },
        {
          _id: "demo-er-2", 
          name: "Fire Emergency Evacuation",
          description: "Standard fire evacuation procedures",
          category: "fire",
          fieldType: "Safety", 
          serviceType: "FireFighter",
          version: "2.1",
          language: "English",
          tags: "fire, evacuation, safety",
          status: "active",
          actions: [
            { name: "Sound the fire alarm", step: "1" },
            { name: "Evacuate via nearest exit", step: "2" },
            { name: "Proceed to assembly point", step: "3" }
          ],
          user: {
            _id: "user2",
            contactName: { first: "Captain", last: "Williams" },
            imageSrc: null
          },
          businessNo: null,
          companyinfo: null,
          createdOn: new Date().toISOString()
        },
        {
          _id: "demo-er-3",
          name: "Cut Wound First Aid", 
          description: "Basic first aid for cuts and wounds",
          category: "cut",
          fieldType: "Medical",
          serviceType: "ProEP",
          version: "1.5",
          language: "English", 
          tags: "first aid, wound, bleeding",
          status: "active",
          actions: [
            { name: "Apply direct pressure", step: "1" },
            { name: "Clean wound if minor", step: "2" },
            { name: "Apply bandage", step: "3" }
          ],
          user: {
            _id: "user3",
            contactName: { first: "Nurse", last: "Smith" },
            imageSrc: null
          },
          businessNo: null,
          companyinfo: null,
          createdOn: new Date().toISOString()
        }
      ];
      
      // Set mock data to allow frontend testing
      this.setState({ 
        erinstructions: mockERInstructions,
        errors: { 
          fetch: "Using demo data. Backend endpoint will be implemented later." 
        }
      });
    }
  }

  handleDelete = (erinstruction) => {
    const erinstructions = this.state.erinstructions.filter(
      (el) => el._id !== erinstruction._id
    );
    this.setState({ erinstructions });
  };
  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
    // Optional: Clear selections when changing pages
    // this.setState({ currentPage: page, checkedFields: [] });
  };

  handleSearch = (query) => {
    this.setState({ searchQuery: query, currentPage: 1 });
  };

  handleCheckboxChange = ({ target: { checked, value } }) => {
    if (checked) {
      this.setState(({ checkedFields }) => ({
        checkedFields: [...checkedFields, value],
      }));
    } else {
      this.setState(({ checkedFields }) => ({
        checkedFields: checkedFields.filter((e) => e !== value),
      }));
    }
  };

  handleToggle = () => {
    const { data: currentPageERInstructions } = this.getDataPagination();
    const { checkedFields } = this.state;
    
    // Get IDs of all items on current page
    const currentPageIds = currentPageERInstructions.map(wi => wi._id);
    
    // Check if all items on current page are selected
    const allCurrentPageSelected = currentPageIds.every(id => checkedFields.includes(id));
    
    if (allCurrentPageSelected) {
      // Unselect all items on current page
      this.setState({ 
        checkedFields: checkedFields.filter(id => !currentPageIds.includes(id))
      });
    } else {
      // Select all items on current page (add any not already selected)
      const newCheckedFields = [...checkedFields];
      currentPageIds.forEach(id => {
        if (!newCheckedFields.includes(id)) {
          newCheckedFields.push(id);
        }
      });
      this.setState({ checkedFields: newCheckedFields });
    }
  };

  handleMassDelete = async (checkedERInstructions) => {
    if (checkedERInstructions.length === 0) {
      toast.warning("Please select items to delete");
      return;
    }

    const originalERInstructions = this.state.erinstructions;
    let deletedCount = 0;
    let errorCount = 0;
    
    try {
      // Process deletions sequentially to avoid overwhelming the server
      for (const erinstructionId of checkedERInstructions) {
        try {
          await deleteERinstruction(erinstructionId);
          deletedCount++;
        } catch (ex) {
          errorCount++;
          if (ex.response && ex.response.status === 404) {
            console.log("ER instruction already deleted:", erinstructionId);
          } else {
            console.error("Failed to delete er instruction:", erinstructionId, ex);
          }
        }
      }
      
      // Update the state by removing all successfully deleted items
      const remainingERInstructions = originalERInstructions.filter(
        (erinstruction) => !checkedERInstructions.includes(erinstruction._id)
      );
      
      this.setState({ 
        erinstructions: remainingERInstructions,
        checkedFields: [] // Clear selections after delete
      });
      
      // Show appropriate toast messages
      if (deletedCount > 0 && errorCount === 0) {
        if (deletedCount === 1) {
          toast.success("ER instruction deleted successfully!");
        } else {
          toast.success(`${deletedCount} er instructions deleted successfully!`);
        }
      } else if (deletedCount > 0 && errorCount > 0) {
        toast.warning(`${deletedCount} deleted successfully, ${errorCount} failed to delete`);
      } else {
        toast.error("Failed to delete er instructions");
      }
    } catch (ex) {
      toast.error("An error occurred during deletion");
      this.setState({ erinstructions: originalERInstructions });
    }
  };

  getDataPagination = () => {
    const {
      pageSize,
      currentPage,
      erinstructions,
      sortColumn,
      searchQuery,
    } = this.state;
    
    let filtered = erinstructions;
    if (searchQuery) {
      filtered = erinstructions.filter(
        (erinstruction) =>
          erinstruction.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          erinstruction.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          erinstruction.serviceType?.toLowerCase().includes(searchQuery.toLowerCase()) ||          
          erinstruction.fieldType?.toLowerCase().includes(searchQuery.toLowerCase()) ||                    
          erinstruction.category?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          erinstruction.username.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
          erinstruction.businessName.toLowerCase().startsWith(searchQuery.toLowerCase())          
      );
    }

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
    const paginatedData = paginate(sorted, currentPage, pageSize);
    return { data: paginatedData };
  };

  render() {
    const { length: count } = this.state.erinstructions;
    const { pageSize, currentPage, sortColumn, searchQuery } = this.state;

    const { data: erInstructions } = this.getDataPagination();

    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/workinstructions/erinstructions/">ER Instructions</Link>
          </li>
        </ol>
        <h1 className="page-header">ER Instructions</h1>
        <Panel>
          <PanelHeader>ER Instructions Management</PanelHeader>

          <React.Fragment>
            <ToastContainer />
            <div className="toolbar" style={toolbarStyles}>
              <Icon
                to={{
                  pathname: "/workinstructions/erinstructions/new",
                  state: {
                    kan: "",
                    prevPage: "",
                  },
                }}
                title="Add ER instruction"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={newIcon}
              />

              <Icon
                to={{
                  pathname: this.state.checkedFields.length > 0
                    ? `/workinstructions/erinstructions/${this.state.checkedFields[0]}`
                    : "/workinstructions/erinstructions/",
                  state: {
                    prevPage: "erinstructions",
                  },
                }}
                title="Edit ER instruction"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={editIcon}
              />

              <Icon
                to="/workinstructions/erinstructions/"
                handleClick={() =>
                  this.handleMassDelete(this.state.checkedFields)
                }
                title="Delete ER Instruction"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={trashIcon}
              />

              <Icon
                to={{
                  pathname: this.state.checkedFields.length > 0
                    ? `/workinstructions/erinstructions/board/${this.state.checkedFields[0]}`
                    : "/workinstructions/erinstructions/",
                  state: {
                    prevPage: "erinstructions",
                  },
                }}
                title="View board"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={eyeIcon}
              />

              <Icon
                to="/erinstructions/"
                title="excel"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={xlsIcon}
              />

              <Icon
                to="/erinstructions/"
                title="csv"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={csvIcon}
              />

              <Icon
                to="/erinstructions/"
                title="pdf"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={pdfIcon}
              />

              <Icon
                to="/erinstructions/"
                title="share"
                btnStyle={btnStyles}
                iconStyle={iconStyles}
                icon={sharingIcon}
              />
            </div>
            <div className="table-responsive">
              <SearchBox value={searchQuery} onChange={this.handleSearch} />
              <p className="page-header float-xl-left" style={{ marginBottom: 5, marginLeft: 20, marginTop: 5 }}>
                {count} entries
              </p>

              <ERInstructionTable
                erInstructions={erInstructions}
                onDelete={this.handleDelete}
                onSort={this.handleSort}
                sortColumn={sortColumn}
                handleCheckboxChange={this.handleCheckboxChange}
                toggle={this.handleToggle}
                checkedFields={this.state.checkedFields}
              />
            </div>
          </React.Fragment>

          <hr className="m-0" />
          <PanelBody>
            <div className="d-flex align-items-center justify-content-center">
              <Pagination
                itemsCount={count}
                pageSize={pageSize}
                onPageChange={this.handlePageChange}
                currentPage={currentPage}
              />
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}
const toolbarStyles = {
  background: "#c8e9f3",
  padding: "10px",
};

const btnStyles = { background: "#348fe2", margin: "0rem" };

const iconStyles = {
  width: "25px",
  height: "25px",
  marginRight: "0rem",
};

export default ERInstructionsTable;
